"use client"

import { useEffect, useRef, useState } from "react"

import {
  TextStagger,
  textStaggerGroupClass,
} from "@modules/products/components/text-stagger"

import styles from "./featured-products.module.css"

type Props = {
  title: string
  subtitle: string
}

export default function FeaturedProductsHeader({ title, subtitle }: Props) {
  const rootRef = useRef<HTMLElement>(null)
  const [revealed, setRevealed] = useState(false)

  useEffect(() => {
    const node = rootRef.current

    if (!node) {
      return
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setRevealed(true)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) {
          return
        }

        setRevealed(true)
        observer.disconnect()
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.01 }
    )

    observer.observe(node)

    return () => observer.disconnect()
  }, [])

  return (
    <header
      ref={rootRef}
      className={`${styles.header}${revealed ? ` ${textStaggerGroupClass}` : ""}`}
    >
      <TextStagger index={0}>
        <h2 className={styles.title}>{title}</h2>
      </TextStagger>
      {subtitle && (
        <TextStagger index={1}>
          <p className={styles.subtitle}>{subtitle}</p>
        </TextStagger>
      )}
    </header>
  )
}
